import { composeWithDevTools } from '@redux-devtools/extension';
import { type AnyAction, applyMiddleware, legacy_createStore as createStore, type Store } from 'redux';
import { type ThunkAction, type ThunkDispatch, thunk } from 'redux-thunk';

import { contactFormApi } from '../../services/contactFormApi';
import { poiApi } from '../../services/poiApi';
import { rootReducer } from '../../services/reducers';
import { trafficApi } from '../../services/trafficApi';

// biome-ignore lint/suspicious/noExplicitAny: We don't know the type
export const configureStore = (preloadedState?: any) => {
    const middlewares = [thunk]
        .concat(contactFormApi.middleware)
        .concat(poiApi.middleware)
        .concat(trafficApi.middleware);
    const middlewareEnhancer = applyMiddleware(...middlewares);

    const composedMiddleware = composeWithDevTools({})(middlewareEnhancer);

    return createStore(rootReducer, preloadedState, composedMiddleware);
};

export const store: Store = configureStore();

export type RootState = ReturnType<typeof store.getState>;

export type RootDispatch = ThunkDispatch<RootState, unknown, AnyAction> & typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, AnyAction>;
